import React, {useEffect} from "react";
import Currency from "common/src/components/widget/Currency";
import {useTranslation} from "react-i18next";
import {toEuroCurrency} from "common/src/utils/CurrencyUtils";

const TrailServiceCard = (props) => {

  const {t} = useTranslation();
  const {
    getField,
    setValue,
    values
  } = props.form;

  useEffect(() => {
    if (!values.days || values.calculatedTrailServicePrice) {
      return
    }
    const calculatedTrailServicePrice = 13 * (values.numberOfAdults + values.numberOfChildren) * values.days.length;
    setValue("calculatedTrailServicePrice", calculatedTrailServicePrice)
  }, [values.numberOfAdults, values.numberOfChildren, values.days]);

  return (
    <div className={"card"}>
      <div className={"card-header"}>
        <p className="card-header-title">
          <span className="icon fz fz-passport mr-1"/>
          <span>{t("offer.trail_service")}</span>
        </p>
      </div>
      <div className={"card-content"}>
        <div className={"column is-3 has-tooltip primary"} data-tooltip={t("offer.calculated_trail_service") + " " + toEuroCurrency(values.calculatedTrailServicePrice)}>
          <Currency label={t("offer.trail_service")}
                    formField={values.trailServicePrice !== undefined ? getField("trailServicePrice") : getField("calculatedTrailServicePrice")}
                    disabled={values.status === "BOOKED" || values.status === "REJECTED"}
          />
        </div>
      </div>
    </div>
  );
}

export default TrailServiceCard;
